import React from 'react'
import styled, { css } from 'styled-components'
import {
	RstIcon,
	Link,
	Text,
	cssTextRegular14,
	color,
	Container,
} from '@rst/ui-ts'
import { useStore } from 'effector-react'
import { useMatchMedia } from '@rst/libs-ts'
import { $info } from '../../../model'
import { openMapModal } from '@rst/render-blocks/src/features/footer/model/map'
import { PreloaderSubHeader } from '../atoms/preloader-sub-header'
import { useSocial } from '../utils'
import { SocialLink } from '../atoms/social-link'

const SubHeader = () => {
	const md = useMatchMedia(md => md.less.md)
	const xs = useMatchMedia(xs => xs.less.xs)
	const { loading, data } = useStore($info)

	const social = useSocial(data.social)

	if (xs) return null
	return (
		<Wrapper>
			{loading === 'done' ? (
				<Main md={md}>
					{social.length ? (
						<Social>
							{social.map(({ type, value }, ind) => (
								<SocialLink icon={type} link={value} key={ind} />
							))}
						</Social>
					) : null}
					<div>
						{!md && data.location ? (
							<Map onClick={() => openMapModal()}>
								<RstIcon type={'rst-map_marker'} />
								<Text>{data.location}</Text>
							</Map>
						) : null}
						<Phone>
							{data.phone && (
								<>
									<RstIcon type={'rst-phone'} />
									<Link href={`tel:${data.phone}`}>{data.phone}</Link>
								</>
							)}
							{data.email ? (
								<>
									{((!md && data.location) || data.phone) && <div>•</div>}
									<Link href={`mailto:${data.email}`}>{data.email}</Link>
								</>
							) : null}
						</Phone>
					</div>
				</Main>
			) : (
				<PreloaderSubHeader />
			)}
		</Wrapper>
	)
}

export { SubHeader }

const Wrapper = styled.div`
	height: 36px;
	background: ${color('gray-19')};
	position: relative;
	z-index: 1;
`

const Main = styled(Container)<{ md: boolean }>`
	height: 100%;
	display: flex;
	justify-content: space-between;
	${({ md }) =>
		md &&
		css`
			flex-direction: row-reverse;
		`}

	align-items: center;
	& > :last-child {
		display: flex;
	}
`
const Social = styled.div`
	& > :not(:last-child) {
		margin-right: 20px;
	}
	i {
		color: ${color('gray-04')};
	}
	a {
		:hover {
			text-decoration: none;
		}
	}
`
const Map = styled.div`
	cursor: pointer;
	margin-right: 50px;
	display: flex;
	align-items: center;
	padding: 5px;
	transition: all 200ms;
	& > * {
		color: ${color('gray-04')};
	}
	i {
		margin-right: 10px;
	}
	${Text} {
		${cssTextRegular14};
	}
	:hover {
		background: ${color('primary-09')};
		border-radius: 5px;
		${Text},
		i {
			color: ${color('gray-04')};
		}
	}
`
const Phone = styled.div`
	display: flex;
	align-items: center;
	& > :not(:first-child) {
		margin-left: 10px;
	}
	& > * {
		display: block;
		color: ${color('gray-04')};
	}
	i {
		font-size: 14px;
	}
	${Text} {
		${cssTextRegular14};
	}
	a {
		padding: 5px;
		transition: all 200ms;
		:hover {
			text-decoration: none;
			background: ${color('primary-09')};
			color: ${color('gray-04')};
			border-radius: 5px;
		}
	}
`
